import { Button, Icon, Tooltip } from "@mui/material";
import React, { Fragment, useImperativeHandle } from "react";
import { useCallback, useState } from "react";
import { Col, FormGroup } from "reactstrap";
import { UncontrolledTooltip } from "reactstrap/lib";
import Swal from "sweetalert2";
import { ButtonDownload } from "../../components/base/Button";
import { Label } from "../../components/base/Label";
import { FontAwesome } from "../../components/icon";
import DocumentViewer from "./components/DocumentViewer";
import { Button as ButtonMUI } from "@mui/material";
import { Typography } from "@mui/material";
import Main from "../../service/GateWay/Main";

// ============================================
// FILE TYPE HELPERS
// ============================================

// Helper function to get file icon info based on extension
const getFileIconInfo = (fileName) => {
  if (!fileName)
    return { icon: "insert_drive_file", color: "#64748b", faIcon: "file" };

  const extension = fileName.split(".").pop()?.toLowerCase();

  switch (extension) {
    case "pdf":
      return { icon: "picture_as_pdf", color: "#ef4444", faIcon: "file-pdf" }; // Red for PDF
    case "doc":
    case "docx":
      return { icon: "description", color: "#2563eb", faIcon: "file-word" }; // Blue for Word
    case "xls":
    case "xlsx":
      return { icon: "table_chart", color: "#16a34a", faIcon: "file-excel" }; // Green for Excel
    case "ppt":
    case "pptx":
      return { icon: "slideshow", color: "#f97316", faIcon: "file-powerpoint" }; // Orange for PowerPoint
    default:
      return { icon: "insert_drive_file", color: "#64748b", faIcon: "file" }; // Gray for others
  }
};

// Helper to check if file is viewable (PDF, Word, Excel, PowerPoint)
const isViewableFile = (fileName) => {
  if (!fileName) return false;
  const extension = fileName.split(".").pop()?.toLowerCase();
  const viewableExtensions = [
    "pdf",
    "doc",
    "docx",
    "xls",
    "xlsx",
    "ppt",
    "pptx",
  ];
  return viewableExtensions.includes(extension);
};

const getEmptyDocSwal = (title) => ({
  title,
  icon: "error",
  confirmButtonText: "Thử lại",
  cancelButtonText: "Đóng",
  cancelButtonColor: "#d33",
});
const handleEmptyDocSwal =
  (callback) =>
  ({ isConfirmed }) => {
    if (!isConfirmed) return;
    callback();
  };
// eslint-disable-next-line no-unused-vars
const onEmptyDoc = (
  callback,
  title = "Không tìm thấy văn bản. Vui lòng thử lại",
) => Swal.fire(getEmptyDocSwal(title)).then(handleEmptyDocSwal(callback));

export const RenderDownload = React.forwardRef(
  (
    {
      file,
      key,
      keySet,
      className,
      isLabel,
      name,
      isEdit,
      onClickPDF,
      stylePDF,
      colLabel,
      colContent,
      ...props
    },
    ref,
  ) => {
    const [activeDoc, setActiveDoc] = useState(undefined);
    const handleFileViewerClose = useCallback(() => setActiveDoc(null), []);
    const openDocument = useCallback(
      (file) => {
        if (file) {
          // let vb = null;
          // if (!vb) return onEmptyDoc(() => openDocument(vb))
          !onClickPDF && setActiveDoc(file);
          onClickPDF && onClickPDF(file);
        }
      },
      [onClickPDF],
    );

    useImperativeHandle(ref, () => ({
      _openDocument: (file) => openDocument(file),
    }));

    if (!file)
      return (
        <ButtonDownload className={className} id={"dowloadVB-LB" + keySet}>
          {"Tải về"}
        </ButtonDownload>
      );
    return (
      <Fragment>
        {isLabel ? (
          <FormGroup row className={`form-control-${name}`}>
            <Col md={colLabel || "5"}>
              <Label>{name}</Label>
            </Col>
            <Col md={colContent || "7"}>
              {stylePDF === "PDF" ? (
                <div className="d-flex align-items-center">
                  <span
                    style={{
                      color: getFileIconInfo(file.name || file?.file?.name)
                        .color,
                    }}
                  >
                    <FontAwesome
                      fa={getFileIconInfo(file.name || file?.file?.name).faIcon}
                    />
                  </span>
                  {isViewableFile(file.name || file?.file?.name) ? (
                    <span
                      className="ml-1 text-left"
                      style={{ fontSize: "0.875rem", cursor: "pointer" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        openDocument(file);
                      }}
                    >
                      {file.name || file.file.name}
                    </span>
                  ) : (
                    <a
                      className="ml-1 text-left"
                      style={{
                        fontSize: "0.875rem",
                        textDecoration: "none",
                        color: "inherit",
                      }}
                      href={Main.getDocUrlByPath(file.path)}
                      download={file.name || file?.file?.name}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {file.name || file.file.name}
                      <Icon
                        sx={{
                          fontSize: 14,
                          ml: 0.5,
                          verticalAlign: "middle",
                          color: "#16a34a",
                        }}
                      >
                        download
                      </Icon>
                    </a>
                  )}
                </div>
              ) : (
                <>
                  {/* <Button onClick={() => openDocument(file)} className="p-0" color="link"><span style={{ color: '#cd201f' }} id={"dowloadVB-LB" + file.type}><FontAwesome fa="file-pdf" /></span><span>{file.name}</span></Button> */}
                  <Tooltip
                    title={file.name || file.file.name}
                    aria-label={file.name || file.file.name}
                  >
                    <Button
                      size="small"
                      color="primary"
                      startIcon={<Icon>download</Icon>}
                      className={className}
                      onClick={() => openDocument(file)}
                      id={"dowloadVB-LB" + file.type + key}
                    >
                      {file.name || file?.file?.name}{" "}
                    </Button>
                  </Tooltip>
                  {/* <UncontrolledTooltip placement="right" target={"dowloadVB-LB" + file.type + key}>{file.name || file.file.name}</UncontrolledTooltip> */}
                </>
              )}
              {activeDoc && (
                <DocumentViewer
                  {...props}
                  isEdit={isEdit}
                  isModal={true}
                  activeDoc={activeDoc}
                  onClose={handleFileViewerClose}
                />
              )}
            </Col>
          </FormGroup>
        ) : (
          <>
            {stylePDF === "PDF" ? (
              <div className="d-flex align-items-center">
                <span style={{ color: getFileIconInfo(file.name).color }}>
                  <FontAwesome fa={getFileIconInfo(file.name).faIcon} />
                </span>
                {isViewableFile(file.name) ? (
                  <span
                    className="ml-1"
                    style={{ fontSize: "0.875rem", cursor: "pointer" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      openDocument(file);
                    }}
                  >
                    {file.name}
                  </span>
                ) : (
                  <a
                    className="ml-1"
                    style={{
                      fontSize: "0.875rem",
                      textDecoration: "none",
                      color: "inherit",
                    }}
                    href={Main.getDocUrlByPath(file.path)}
                    download={file.name}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {file.name}
                    <Icon
                      sx={{
                        fontSize: 14,
                        ml: 0.5,
                        verticalAlign: "middle",
                        color: "#16a34a",
                      }}
                    >
                      download
                    </Icon>
                  </a>
                )}
              </div>
            ) : (
              <>
                {/* <Button onClick={() => openDocument(file)} className="p-0" color="link"><span style={{ color: '#cd201f' }} id={"dowloadVB" + key}><FontAwesome fa="file-pdf" /></span><span>{file.name}</span></Button> */}
                <Tooltip title="Tải Xuống">
                  <ButtonMUI
                    id={"dowloadVB" + keySet + key}
                    size="small"
                    variant="contained"
                    startIcon={<Icon fontSize="small">download</Icon>}
                    onClick={() => openDocument(file)}
                  >
                    <Typography fontSize={13} textTransform="initial">
                      Tải về
                    </Typography>
                  </ButtonMUI>
                </Tooltip>
              </>
            )}
            {activeDoc && (
              <DocumentViewer
                {...props}
                isEdit={isEdit}
                isModal={false}
                activeDoc={activeDoc}
                onClose={handleFileViewerClose}
              />
            )}
          </>
        )}
      </Fragment>
    );
  },
);
